import { SYNC_REASON_CODES } from '../../configuration/orders/fabricationOrderAlignmentCell'

/**
 * JUP-6 (historia 108, S97) — qué texto pone la columna del motivo de **Peticiones pendientes**.
 *
 * ⚠️ Solo esa pantalla. El histórico lo usó hasta la decisión 3 de Iosu (2026-09-11): allí el código
 * venía nulo casi siempre, así que aquella columna volvió al texto del servidor. Aquí el campo sí
 * llega y sí sirve.
 *
 * El problema que resuelve: hasta ahora esa columna pintaba lo que Sun compone en
 * `describeFailure()`, una cadena de excepciones Java (`ReplicaNotDeletable: Fabrication order
 * 'OF-1001' cannot be deleted here…`). Y no es cosmético: en S97 planta borra una OF, la célula
 * rechaza por producción en curso y la OF **ya no existe en planta**, así que no hay fila en la
 * ventana de OFs donde pintar el indicador — esa fila fallida es el ÚNICO aviso de la divergencia.
 *
 * Sun publica ahora `reasonCode` desnudo junto al texto viejo, que se queda como diagnóstico
 * (`contrato-sun.md` §2/§3, commit `92a6206`). Tres reglas, y las tres importan:
 *
 *   1. **Código conocido → traducido.** Son las mismas claves que ya usa el indicador de la ventana
 *      de OFs, así que la columna y la celda dicen la misma palabra para el mismo hecho.
 *   2. **Código ausente → el texto de siempre.** Es el caso NORMAL: una petición que solo espera no
 *      es un rechazo, así que no trae código.
 *   3. **Código DESCONOCIDO → el texto de siempre, nunca el código.** Sun deja pasar tal cual un
 *      código de otro recurso en vez de degradarlo a `OTHER`; enseñar ese identificador a una
 *      persona es exactamente la bandera JUP-2. Se prefiere decir menos.
 *
 * @param {string} [reasonCode] Código estable de Sun, o nada
 * @param {string} [fallback] Texto diagnóstico de la fila (`description`)
 * @param {Function} t_ Translation function of the screen
 * @returns {string} Lo que se muestra en la celda
 */
export const clusterSyncReasonText = (reasonCode, fallback, t_) =>
  SYNC_REASON_CODES.includes(reasonCode) ? t_(reasonCode) : (fallback || '')

export default clusterSyncReasonText
